import { getThread } from '../../../omnibus/public/operators';
import { ThreadDetails } from 'conversations-thread-data/thread-details/public/records';
export const buildThreadDetailsFromOmnibus = omnibus => {
  const thread = getThread(omnibus);
  /*  @ts-expect-error Jun-7-2024, 14:44UTC TODO: fix broken types introduced from typing of ThreadDetails record: https://git.hubteam.com/HubSpot/conversations-thread-view/pull/3656  */
  if (thread) return new ThreadDetails(thread);
  return null;
};